<template>
    <div class="bg-white pb-30">
        <scroll-active class="fixed z-2 left-1/2 top-1/2 ml-165 rounded bg-white px-2 py-1" :class="$style.shadow" active-class="text-[#3F8F9A]">
            <a  class="scrollactive-item select-none block p-2 bg-white rounded w-11 text-sm cursor-pointer transition-colors hover:text-[#3F8F9A] hover:bg-tonal active:bg-light active:text-opacity-80"
                data-section-selector=".j_module-1">
                八大升级
            </a>
            <a class="scrollactive-item select-none block p-2 bg-white rounded w-11 text-sm cursor-pointer transition-colors hover:text-[#3F8F9A] hover:bg-tonal"
                data-section-selector=".j_module-2">
                行程安排
            </a>
            <a class="scrollactive-item select-none block p-2 bg-white rounded w-11 text-sm cursor-pointer transition-colors hover:text-[#3F8F9A] hover:bg-tonal"
                data-section-selector=".j_module-3">
                邮轮介绍
            </a>
            <a class="scrollactive-item select-none block p-2 bg-white rounded w-11 text-sm cursor-pointer transition-colors hover:text-[#3F8F9A] hover:bg-tonal"
                data-section-selector=".j_module-4">
                景点介绍
            </a>
            <a class="scrollactive-item select-none block p-2 bg-white rounded w-11 text-sm cursor-pointer transition-colors hover:text-[#3F8F9A] hover:bg-tonal"
                data-section-selector=".j_module-5">
                产品预订
            </a>
        </scroll-active>
        <div class="overflow-hidden">
            <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
                <picture class="object-cover mx-auto">
                    <img src="~@/assets/img/topic/2023/jsrcdj/img-1.jpg" alt="江山如此多娇" />
                </picture>
                <picture class="object-cover mx-auto j_module-1">
                    <img src="~@/assets/img/topic/2023/jsrcdj/img-2.jpg" alt="江山如此多娇" />
                </picture>
                <picture class="object-cover mx-auto j_module-2">
                    <img src="~@/assets/img/topic/2023/jsrcdj/img-3.jpg" alt="江山如此多娇" />
                </picture>
                <div class="j_module-3">
                    <picture class="object-cover mx-auto">
                        <img src="~@/assets/img/topic/2023/jsrcdj/img-4.jpg" alt="江山如此多娇" />
                    </picture>
                    <picture class="object-cover mx-auto">
                        <img src="~@/assets/img/topic/2023/jsrcdj/img-5.jpg" alt="江山如此多娇" />
                    </picture>
                    <picture class="object-cover mx-auto">
                        <img src="~@/assets/img/topic/2023/jsrcdj/img-6.jpg" alt="江山如此多娇" />
                    </picture>
                    <picture class="object-cover mx-auto">
                        <img src="~@/assets/img/topic/2023/jsrcdj/img-7.jpg" alt="江山如此多娇" />
                    </picture>
                </div>
                <picture class="object-cover mx-auto j_module-4">
                    <img src="~@/assets/img/topic/2023/jsrcdj/img-8.jpg" alt="江山如此多娇" />
                </picture>
            </div>
        </div>
        <div class="-mt-47 relative j_module-5">
            <div class="main-width ">
                <div v-for="item in state.jhfu" class="flex bg-white my-10 rounded" :class="$style.shadow">
                    <a :href="`/product/cruise/${item.product_no}`" target="_blank">
                        <el-image class="w-123 h-79 block rounded" :src="item.image" :alt="item.name" />
                    </a>
                    <div class="flex-1 px-10 py-8 relative">
                        <h3><a class="text-dark text-2xl font-medium transition-colors line-clamp-2 hover:text-[#3F8F9A]"
                                :href="`/product/cruise/${item.product_no}`" target="_blank">{{ item.name }}</a></h3>
                        <div class="flex flex-wrap mt-5">
                            <div class="px-3 py-2 bg-[#BC8B05] bg-opacity-20 leading-snug text-[#BC8B05] rounded siblings:ml-3"
                                v-for="tag in item.tags">{{ tag }}</div>
                        </div>
                        <div class="text-dark mt-5 font-medium"><span class="text-xl">¥</span><span class="text-2xl">{{
                            item.price }}</span><span class="text-lg">起</span></div>
                        <div class="mt-5 text-lg"><i class="ficon ficon-dangqianweizhi mr-1"></i>{{ item.departure }}</div>

                        <a :href="`/product/cruise/${item.product_no}`" target="_blank"
                            class="absolute rounded-full text-lg right-10 bottom-8 px-4 py-2 leading-snug bg-[#3F8F9A] text-white transition-colors hover:bg-opacity-70 active:bg-opacity-90">查看详情</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import useRequest from '~/composables/useRequest';
import { getJsrcdj2023 } from '~/services/special';

import ScrollActive from '~/components/ScrollActive'
export default defineComponent({
    name: 'JsrcdjPage',
    auth: false,

    components: {
        ScrollActive
    },
    head: {},
    setup() {
        useMeta(() => {
            return {
                title: '江山如此多娇'
            }
        })
        const { state } = useRequest(getJsrcdj2023, {
            jhfu: []
        })

        return {
            state
        }
    }
})
</script>

<style lang="scss" module>

.shadow {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
}

</style>